import HeroPlayButton from "./HeroPlayButton";
import HeroProviderLogo from "./HeroProviderLogo";
import HeroRandomGameButton from "./HeroRandomGameButton";
import HeroStats from "./HeroStats";
import type { HighlightedGameSlide } from "./types";

type Props = {
  slide: HighlightedGameSlide;
  providerName: string;
  logoUrl?: string;
  totalGamesCount?: number;
  randomGameHrefs?: string[];
  translations: Record<string, string>;
};

const HeroCopyOverlay: FC<Props> = ({
  slide,
  providerName,
  logoUrl,
  totalGamesCount,
  randomGameHrefs,
  translations,
}) => (
  <div
    data-slot="hero-copy-overlay"
    className="pointer-events-none relative hidden flex-col items-start gap-5 p-7 md:flex [&_a,&_button]:pointer-events-auto"
  >
    <div className="flex flex-col items-start">
      {logoUrl && (
        <HeroProviderLogo
          url={logoUrl}
          providerName={providerName}
          align="left"
          className="xl:max-w-40"
        />
      )}
      {slide.isProvider ? (
        <h1 className="font-headline! font-semibold text-[32px]/9 text-white xl:text-[40px]/11">
          {slide.title}
        </h1>
      ) : (
        <h2 className="font-headline! font-semibold text-[32px]/9 text-white xl:text-[40px]/11">
          {slide.title}
        </h2>
      )}
    </div>
    {slide.description && (
      <p className="line-clamp-2 max-w-146.25 font-semibold text-sm/5 text-white/80">
        {slide.description}
      </p>
    )}
    <div className="flex w-full items-center gap-6">
      {slide.isProvider
        ? randomGameHrefs && (
            <HeroRandomGameButton
              hrefs={randomGameHrefs}
              label={translations["widget.highlighted-games.random-game"]}
            />
          )
        : slide.href && (
            <HeroPlayButton
              href={slide.href}
              label={translations["widget.highlighted-games.play-now"]}
            />
          )}
      <HeroStats
        totalGamesCount={totalGamesCount}
        likes={slide.likes}
        translations={translations}
      />
    </div>
  </div>
);

export default HeroCopyOverlay;
